import TYPES from './types'

export default {
  [TYPES.SPINNER.GET]: (state) => state
}
